import { render, staticRenderFns } from "./ListaOpcoes.vue?vue&type=template&id=00ec0c64"
import script from "./ListaOpcoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaOpcoes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports